<!-- 编辑设备详情弹框 -->
<template>
  <div class="tree-container">
    <div class="area-search">
      <el-input
        v-model="searchString"
        clearable
        placeholder="请输入搜索关键字"
      >
      </el-input>
      <!-- @clear="clearSearch" -->
    </div>
    <el-scrollbar class="scroll-bar-view">
      <el-tree
        v-if="showTree"
        ref="tree"
        class="tree-content"
        :data="treeData"
        :show-checkbox="multiCheck"
        :expand-on-click-node="false"
        node-key="thirdCameraId"
        render-after-expand
        :default-expanded-keys="expandedKeys"
        :load="asyncLoadNode"
        :lazy="lazyLoad"
        :props="treeProps"
        :highlight-current="true"
        :filter-node-method="filterNode"
        @check="checkChange"
      >
      </el-tree>
    </el-scrollbar>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic, Cache, Base } from "$utils";
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};

export default {
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  props: {
    highTreeNode: {
      type: String,
      default: () => {
        return "";
      },
    },
    multiCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandedKeys: [],
      searchString: "",
      showTree: true,
      treeData: Object.freeze([]),
      lazyLoad: false,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      checkedWorkgroup: [],
      checkedDevice: [],
    };
  },
  mounted() {
    this.getEquipmentTree();
  },
  methods: {
    // 设置节点高亮
    setHighlightNode(id) {
      this.$refs.tree.setCurrentKey(id);
    },
    // 检索树
    filterText() {
      if (!this.searchString) {
        this.showTree = false;
        this.$nextTick(() => {
          this.showTree = true;
        });
        this.getEquipmentTree();
        return;
      }
      this.$refs.tree.filter(this.searchString.trim());
    },
    //重置
    clearSearch() {
      this.searchString = "";
      this.filterText();
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.title.indexOf(value) !== -1;
    },
    //获取摄像机工作组树列表
    getEquipmentTree() {
      const self = this;
      let params = {
        deviceType: 10,
      };
      this.$fetch(api.queryDeviceWorkGroupDeviceTree, params).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        self.cacheTree = result;
        self.treeData = Object.freeze(result);
        // self.expandedKeys = [self.treeData[0].thirdCameraId];
        console.log(this.treeData)
        self.$nextTick(() => {
          if (this.highTreeNode !== "") {
            this.$refs.tree.setCurrentKey(this.highTreeNode);
          }
        });
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.abscissa = item.abscissa;
          entity.buildingCode = item.buildingCode;
          entity.deviceMark = item.deviceMark;
          entity.deviceType = item.deviceType;
          entity.fileCode = item.fileCode;
          entity.height = item.height;
          entity.id = item.id;
          entity.inlineCount = item.inlineCount;
          entity.isVisible = item.isVisible;
          entity.name = item.name;
          entity.nodeType = item.nodeType;
          entity.ordinate = item.ordinate;
          entity.parentCodes = item.parentCodes;
          entity.parentDeviceId = item.parentDeviceId;
          entity.parentId = item.parentId;
          entity.status = item.status;
          entity.subDeviceMark = item.subDeviceMark;
          entity.width = item.width;
          entity.thirdCameraId = item.thirdCameraId;
          entity.totalCount = item.totalCount;
          entity.title = "【" + item.thirdCameraId + "】" + item.name;
          entity.isLeaf = !item.hasLeaf || !item.children;
          if (item.children) {
            entity.children = self.menusDataPro(item.children);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 多选
    checkChange(node, checkData) {
      // console.log('---node----', node);
      // console.log('---checkData----', checkData);
      // 当前被选中节点
      let checkNodes = checkData.checkedNodes;
      this.checkedWorkgroup = [];
      this.checkedDevice = [];
      checkNodes.forEach((item) => {
        if (item.nodeType != "workgroup") {
          this.checkedDevice.push(item);
        } else {
          this.checkedWorkgroup.push(item);
        }
      });
      this.$emit("cameraData", this.checkedDevice, this.checkedWorkgroup);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.tree-container {
  height: 500px;
  // padding: 0px 5px;
  .area-search {
    display: flex;
    margin-bottom: 12px;
    height: 28px;
    .el-input {
      // margin-right: 10px;
      width: 100%;
    }
  }
  .scroll-bar-view {
    // @include set_theme_color(background-color, top-menu-bg-color);
    height: calc(100% - 40px);
    padding-bottom: 12px;
    .el-scrollbar__wrap {
      // overflow-x: hidden;
      height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      // text-overflow: ellipsis;
      // overflow: hidden;
      // white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
        .tree-icon {
          margin-right: 2px;
          @include set_theme_color(color, font-active-color);
        }
        .node-title {
          margin-bottom: -2px;
          display: inline-block;
          // width: 145px;
          margin-left: 4px;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // word-break: break-all;
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
}
</style>
